/**
 * Initialize Dropdown toggle
 * Just a simple dropdown popup with no animations
 * Hides dropdown with outside click by default
 *
 * @class Dropdown
 */

import isDescendant from './is-descendant';
import DelegateListener from './delegate-listener';

class Dropdown {

  constructor(elem, params = {}) {
    this.dropdown = elem;
    if (this.dropdown.classList.contains('initialized')) { // Already initialized
      return;
    }

    // Use trigger inside (in case content changes via js) dropdown receives click events instead of button
    this.triggerInside = typeof params.triggerInside !== 'undefined' ? params.triggerInside : this.dropdown.getAttribute('data-trigger-inside');

    // Use button
    this.button = !this.triggerInside ? typeof params.button !== 'undefined' && params.button ? params.button : this.dropdown.getElementsByClassName('js-dropdown-button') : false;

    // Callbacks
    this.callbackOpen = typeof params.callbackOpen === 'function' ? params.callbackOpen : null;
    this.callbackClose = typeof params.callbackClose === 'function' ? params.callbackClose : null;

    // Visible class for dropdown
    this.visibleClass = 'is-visible-dropdown'; // Shall not override this one

    if (!this.dropdown) {
      console.warn('class Dropdown could not initialize', { class: this });
      return;
    }

    this.dropdown.classList.add('initialized');

    // Initialize toggle event listeners
    if (this.button) {
      for (var i = 0; i < this.button.length; i++) {
        this.button[i].addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggle();
        });
      }
    }

    // Listen to dropdown clicks, triggers toggle if trigger inside has been clicked
    if (this.triggerInside) {
      DelegateListener('click', this.triggerInside, (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggle();
      }, this.dropdown);
    }

    // Listen for custom close event
    this.dropdown.addEventListener('close', (e) => {
      this.close();
    });

    // By default, outside click hides the content
    // by setting data-toggle-outside-click="anythingbutyes" does not
    const outsideClick = typeof params.hideWithOutsideClick !== 'undefined' ? params.hideWithOutsideClick : this.dropdown.getAttribute('hide-with-outside-click');
    if(!outsideClick || outsideClick === 'yes') {
      document.body.addEventListener('click', (e) => {
        // If the target of the click isn't the container
        const dropdownClicked = isDescendant(this.dropdown, e.target);
        if (!dropdownClicked && this.dropdown.classList.contains(this.visibleClass)) {
          this.close();
        }
      });
    }
  }

  toggle() {
    if (this.dropdown.classList.contains(this.visibleClass)) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    // Hide other dropdowns that are visible
    const visibleDropdowns = document.body.querySelectorAll('.' + this.visibleClass);
    for (var i = 0; i < visibleDropdowns.length; i++) {
      // Create custom close event for dropdown
      const closeEvent = new Event('close');

      // Dispatch the event
      visibleDropdowns[i].dispatchEvent(closeEvent);
    }

    // Open this one
    this.dropdown.classList.add(this.visibleClass);

    // Callback
    if (this.callbackOpen) {
      this.callbackOpen();
    }
  }

  close() {
    this.dropdown.classList.remove(this.visibleClass);

    // Callback
    if (this.callbackClose) {
      this.callbackClose();
    }
  }
}


export { Dropdown };
